import * as React from "react";

import { ExperimentEditContext } from "@v1/features/experiments/contexts/ExperimentEditContext";
import { useRequiredContext } from "replo-utils/react/context";

export function useExperimentEdit() {
  return useRequiredContext(ExperimentEditContext);
}
